module.exports = __webpack_public_path__ + "assets/images/reviews_bg_img.db21d851.jpg";